import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { getConfig } from "@jti/fe-common";
import { useMessageBus } from "@jti/fe-message-bus";
import { ConditionalView, LoadingLayer, useUser } from "@jti/rip";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { Button } from "@jti/ui/components/Button";
import { Toaster } from "@jti/ui/components/Toaster";
import { useAddProduct } from "../../hooks/useAddProduct";
import "./style.scss";
export const redirectToTrialAuthWithBack = () => {
    const config = getConfig();
    return (window.location.href = `${config.AUTH_PAGE_URL}#/login?returnUrl=${config.FREE_TRIAL_PAGE_URL}`);
};
export const ProductTryNowButton = ({ sku, label, isBundle, productPageUrl }) => {
    const messageBus = useMessageBus();
    const { isRunning, addProductToCart } = useAddProduct(sku, [], true);
    const { isLoggedIn } = useUser();
    const [isCartLoaded, setCartState] = useState(false);
    useEffect(() => {
        messageBus.subscribe({
            channel: "cart.loaded",
            callback: () => {
                setCartState(true);
            },
        });
    }, []);
    const handleTryButtonClick = () => {
        if (!isLoggedIn && !isBundle) {
            redirectToTrialAuthWithBack();
        }
        else {
            dispatchTrackingEvent(TrackingEvents.TrackingFreeTrialStart);
            addProductToCart();
        }
    };
    const renderButton = () => {
        if (isBundle) {
            return (_jsxs(_Fragment, { children: [_jsx("a", { href: productPageUrl, className: "aem-productTeaserComponent__link", tabIndex: -1, "aria-hidden": true }), _jsx(Button, { isPending: !isCartLoaded && !!isLoggedIn, color: "primary", onClick: handleTryButtonClick, "data-testid": "teaserTryNowButton", className: "product-teaser-try-now__button", theme: "light", href: productPageUrl, children: label })] }));
        }
        return (_jsxs(_Fragment, { children: [_jsx("button", { type: "button", className: "aem-productTeaserComponent__link", onClick: handleTryButtonClick, tabIndex: -1, "aria-hidden": true }), _jsx(Button, { isPending: !isCartLoaded && !!isLoggedIn, color: "primary", onClick: handleTryButtonClick, "data-testid": "teaserTryNowButton", className: "product-teaser-try-now__button", theme: "light", children: label })] }));
    };
    return (_jsxs("div", { className: "product-teaser-try-now", children: [_jsx(LoadingLayer, { isVisible: isRunning }), _jsx(ConditionalView, { condition: !isRunning, children: renderButton() }), _jsx(Toaster, {})] }));
};
//# sourceMappingURL=ProductTryNowButton.js.map